module.exports = __webpack_public_path__ + "static/media/home-girl.1320d02b.png";